module.exports = __webpack_public_path__ + "img/jue.978e9864.jpg";